import absence from './absence.json';
import admin from './admin.json';
import admissions from './admissions.json';
import ana from './ana.json';
import assessments from './assessments.json';
import attendance from './attendance.json';
import authentication from './authentication.json';
import calendar from './calendar.json';
import classListManager from './classListManager.json';
import common from './common.json';
import extensionPoints from './extensionPoints.json';
import documentation from './documentation.json';
import fees from './fees.json';
import forms from './forms.json';
import groups from './groups.json';
import infoRequests from './infoRequests.json';
import drives from './drives.json';
import mail from './mail.json';
import navigation from './navigation.json';
import noticeBoard from './noticeBoard.json';
import people from './people.json';
import printing from './printing.json';
import reports from './reports.json';
import roomBooking from './roomBooking.json';
import rules from './rules.json';
import scheduling from './scheduling.json';
import schoolActivities from './schoolActivities.json';
import settings from './settings.json';
import sms from './sms.json';
import subjectOptions from './subjectOptions.json';
import substitution from './substitution.json';
import templates from './templates.json';
import timetable from './timetable.json';
import tyroTuition from './tyroTuition.json';

export const en = {
  absence,
  admin,
  admissions,
  ana,
  assessments,
  attendance,
  authentication,
  calendar,
  classListManager,
  common,
  documentation,
  extensionPoints,
  fees,
  forms,
  groups,
  infoRequests,
  drives,
  mail,
  navigation,
  noticeBoard,
  people,
  printing,
  reports,
  roomBooking,
  rules,
  scheduling,
  schoolActivities,
  settings,
  sms,
  subjectOptions,
  substitution,
  templates,
  timetable,
  tyroTuition,
};
